import { Field } from 'formik';
import { AccountsAutocomplete } from '../../../accounts/inputs/AccountsAutocomplete';

export const FilterFormComponent = () => {
    return (
        <Field
            name="adminAccountId"
            label="Admin Account"
            component={AccountsAutocomplete}
            my="md"
        />
    );
};
